module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_hogar.4ebcae67.jpg";